/**
 * Normaliza comissão de afiliado para o v-money 0.8.1.
 * format(null) chama null.indexOf e gera TypeError (VSUS-1460).
 * Usa == null (não || 0) para não zerar strings/valores válidos.
 */
export function normalizeProductComission(comission) {
  return comission == null ? 0 : comission;
}

export function ensureComissionForAffiliation(product) {
  if (!product || !product.affiliation) {
    return product;
  }
  product.comission = normalizeProductComission(product.comission);
  return product;
}

/**
 * Espelha a regra atual do save: affiliation ligado + comission falsy (inclui 0) bloqueia.
 */
export function prepareAffiliationComissionForSave(comission) {
  if (!comission) {
    return { blocked: true };
  }
  return {
    blocked: false,
    comission: parseFloat(String(comission).replace(",", ".")),
  };
}
